import React from 'react';
import { autobind } from 'core-decorators';
import http from 'src/services/httpService';
import { Form, Schema } from '../../../utils/form';
import Button from '../../../componentes/button';
import Dialog from '../../dialog';
import DragDrop from '../../../paginas/configuracao-colunas-arquivo/componentes/drag-drop';
import errorHandler from '../../../utils/error-handler';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import LoadingContainer from '../../../componentes/loading-container';
import ContentManager from '../../../componentes/content-manager';
import { enqueueSnackbar } from 'notistack';
import './colunas-tabela.css';

const estiloRodapeModal = {
  borderRadius: '0 0 16px 16px',
  borderTop: '1px solid #E4E4E7',
  background: '#FAFAFA',
  padding: '16px 24px',
};

const estiloTituloModal = {
  fontSize: 18,
  fontWeight: 700,
  color: '#09090B',
};

const estiloHeaderModal = {
  padding: '16px 16px 0',
};

const estiloContentModal = {
  padding: 0,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
};

@autobind
class ConfirmacaoReplicarColunas extends React.Component {
  handleCancelar() {
    this.refs.dialog.close();
  }

  handleConfirmar() {
    this.props.handleConfirm && this.props.handleConfirm();
    this.refs.dialog.close();
  }

  render() {
    const { intl, colaboradores } = this.props;

    const actions = [
      <Button
        key="cancelar"
        color="secondary"
        className="colunasTabelaBotaoCancelar"
        onClick={this.handleCancelar}
      >
        {intl.formatMessage({ id: 'label.cancelar' })}
      </Button>,
      <Button
        key="confirmar"
        color="primary"
        className="ml-2 colunasTabelaBotao"
        onClick={this.handleConfirmar}
      >
        {intl.formatMessage({ id: 'simReplicarParaTodos' })}
      </Button>,
    ];

    return (
      <Dialog
        ref="dialog"
        title={intl.formatMessage(
          { id: 'replicarEstaConfiguracaoParaTodosOsColaboradores' },
          { colaboradores }
        )}
        textCapitalizeTitle={false}
        titleCapitalizeNone
        styleTitle={estiloTituloModal}
        styleHeader={estiloHeaderModal}
        styleFooter={estiloRodapeModal}
        actions={actions}
        width={560}
        padContent
        remove={this.props.remove}
        onRequestClose={this.handleCancelar}
        mouseDownClose={false}
      >
        <div className="colunasTabelaConfirmacaoTexto">
          {intl.formatMessage(
            { id: 'msgReplicarConfiguracaoColunasParaColaboradores' },
            { colaboradores }
          )}
        </div>
      </Dialog>
    );
  }
}

let schema = Schema.object({
  listaColunasDisponiveis: Schema.array().label(
    <FormattedMessage id="label.colunasDisponiveis" />
  ),
  listaColunasUsadas: Schema.array().label(
    <FormattedMessage id="label.colunasUsadas" />
  ),
});

@autobind
class ColunasTabela extends React.Component {
  static defaultProps = {
    salvarColunas: true,
    palavraChave: 'Colunas',
    modal: true,
    exibirCancelar: true,
    exibirReplicacao: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      replicarColunas: false,
      alterarColunas: false,
    };

    this.form = new Form({
      component: this,
      schema: schema,
    });
  }

  componentDidMount() {
    this.getReplicarColunasPermission();
    this.getAlterarColunasPermission();

    let colunasUsadas =
      this.props.columns && this.props.columns.length > 0
        ? this.props.columns.filter((c) => c?.visible)
        : this.props.allColumns.filter((c) => c?.visible && c?.default);

    this.form.getModel('listaColunasUsadas').requestChange(colunasUsadas);

    if (this.props.allColumns) {
      let colunasDisponiveis = this.props.allColumns
        .filter(
          (e) =>
            colunasUsadas &&
            !colunasUsadas.find((a) => a?.valueField === e?.valueField)
        )
        .filter((c) => c?.visible);

      this.form
        .getModel('listaColunasDisponiveis')
        .requestChange(colunasDisponiveis);
    }
  }

  handleClose() {
    if (this.props.modal) this.refs.dialog.close();
    else this.props.close();
  }

  getReplicarColunasPermission() {
    http
      .get(`/Colaborador/ObterPermissaoReplicacaoColunas`)
      .then((response) => {
        this.setState({
          replicarColunas: response.data.replicarColunas,
        });
      })
      .catch((error) => {
        errorHandler(error);
      });
  }

  getAlterarColunasPermission() {
    http
      .get(`/ColunasTabela/ObterPermissaoAlterarColunas`)
      .then((response) => {
        this.setState({
          alterarColunas: response.data.alterarColunas,
        });
      })
      .catch((error) => {
        errorHandler(error);
      });
  }

  handleSalvarClick() {
    if (this.props.salvarColunas) {
      this.setState({
        isLoading: true,
      });

      http
        .post(`/ColunasTabela/SalvarConfiguracoesColunasTabela`, {
          model: this.form.getValue(),
          tag: this.props.tag,
        })
        .then(() => {
          this.setState({
            isLoading: false,
          });

          this.props.handleAtualizarColunas &&
            this.props.handleAtualizarColunas(
              this.form.getModel('listaColunasUsadas').value
            );
          this.handleClose();
        })
        .catch((error) => {
          this.setState({
            isLoading: false,
          });
          errorHandler(error);
        });
    } else {
      this.props.handleAtualizarColunas &&
        this.props.handleAtualizarColunas(
          this.form.getModel('listaColunasUsadas').value
        );
      this.handleClose();
    }
  }

  handleAbrirConfirmacaoReplicar() {
    ContentManager.addContent(
      <ConfirmacaoReplicarColunas
        intl={this.props.intl}
        colaboradores={this.props.resources.colaboradores}
        handleConfirm={this.handleReplicarClick}
      />
    );
  }

  handleReplicarClick() {
    this.setState({
      isLoading: true,
    });

    http
      .post(`/ColunasTabela/ReplicarColunasDoAdminParaTodos`, {
        model: this.form.getValue(),
        tag: this.props.tag,
      })
      .then(() => {
        this.setState({
          isLoading: false,
        });

        enqueueSnackbar(
          this.props.intl.formatMessage(
            { id: 'colunasForamReplicadasComSucesso' },
            { colaboradores: this.props.resources.colaboradores }
          ),
          { variant: 'success' }
        );
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        errorHandler(error);
      });
  }

  handleFecharClick() {
    document.body.classList.remove('modal-open');
    this.handleClose();
  }

  renderTitulo() {
    let titulo = this.props.palavraChave;

    if (titulo === 'Colunas') return 'label.configuracaoDeColunas';
    else if (titulo === 'Campos') return 'configuracaoDeCampos';
    else if (titulo == 'Favoritos') return 'dashboardsFavoritos';
  }

  renderContent() {
    return (
      <div className="colunasTabelaConteudo">
        <DragDrop
          layoutNovo
          isValidDragToUsedColumns={this.props.isValidDragToUsedColumns}
          palavraChave={this.props.palavraChave}
          listaColunasDisponiveis={this.form.getModel(
            'listaColunasDisponiveis'
          )}
          listaColunasUsadas={this.form.getModel('listaColunasUsadas')}
          esconderColunasDisponiveis={!this.state.alterarColunas}
        />
      </div>
    );
  }

  renderRodape() {
    const { resources, intl, exibirReplicacao } = this.props;

    const replicar =
      exibirReplicacao && this.state.replicarColunas ? (
        <Button
          color="link"
          className="p-0 colunasTabelaLinkReplicar"
          onClick={this.handleAbrirConfirmacaoReplicar}
        >
          {intl.formatMessage(
            { id: 'label.replicarParaColaboradores' },
            { colaboradores: resources.colaboradores }
          )}
        </Button>
      ) : null;

    const acoesDireita = (
      <div>
        {this.props.exibirCancelar && (
          <Button
            color="secondary"
            className="colunasTabelaBotaoCancelar"
            onClick={this.handleFecharClick}
          >
            {intl.formatMessage({ id: 'label.cancelar' })}
          </Button>
        )}
        <Button
          color="primary"
          className="ml-2 colunasTabelaBotao"
          onClick={this.handleSalvarClick}
        >
          {intl.formatMessage({ id: 'label.salvar' })}
        </Button>
      </div>
    );

    return { replicar, acoesDireita };
  }

  render() {
    const { intl } = this.props;
    const { replicar, acoesDireita } = this.renderRodape();

    const acoesDialog = [
      <Button
        key="cancelar"
        color="secondary"
        className="colunasTabelaBotaoCancelar"
        onClick={this.handleFecharClick}
      >
        {intl.formatMessage({
          id: this.props.exibirCancelar ? 'label.cancelar' : 'label.fechar',
        })}
      </Button>,
      <Button
        key="salvar"
        color="primary"
        className="ml-2 colunasTabelaBotao"
        onClick={this.handleSalvarClick}
      >
        {intl.formatMessage({ id: 'label.salvar' })}
      </Button>,
    ];

    const estiloRodape = {
      ...estiloRodapeModal,
      marginTop: 16,
    };

    return this.props.modal ? (
      <Dialog
        {...this.props}
        title={intl.formatMessage({ id: this.renderTitulo() })}
        textCapitalizeTitle={false}
        titleCapitalizeNone
        respeitarAltura
        styleContent={estiloContentModal}
        styleTitle={estiloTituloModal}
        styleHeader={{ padding: 16 }}
        styleFooter={estiloRodape}
        removeTitleMargin
        footer={replicar}
        actions={acoesDialog}
        width={this.props.width || 800}
        height={this.props.height || 672}
        maxHeight="95%"
        onRequestClose={this.handleClose}
        mouseDownClose={false}
        ref="dialog"
      >
        <LoadingContainer
          isLoading={this.state.isLoading}
          className="colunasTabelaLoading"
        >
          {this.renderContent()}
        </LoadingContainer>
      </Dialog>
    ) : (
      <div>
        {this.renderContent()}
        <div className="colunasTabelaRodapeInline">
          <div>{replicar}</div>
          {acoesDireita}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(ColunasTabela));
